/**
 * Navigation between form steps
 */

class StepNavigator {
  constructor(formElement) {
    this.form = formElement;
    this.currentStep = 1;
  }

  /**
   * Go to step
   */
  goToStep(stepName) {
    // Find all step elements
    const allSteps = this.form.querySelectorAll('.auth-form__step');
    const nextStepEl = this.form.querySelector(`.auth-form__step--${stepName}`);

    // Hide all steps
    allSteps.forEach((step) => {
      // eslint-disable-next-line no-param-reassign
      step.style.display = 'none';
    });

    // Show target step
    if (nextStepEl) {
      // eslint-disable-next-line no-param-reassign
      nextStepEl.style.display = 'initial';
      this.currentStep = parseInt(nextStepEl.dataset.step, 10) || this.currentStep;
    }
  }
}

export default StepNavigator;
